<template>
  <div>
    <DialogWrapper v-if="dialogType === 'showBindAccount'" :class="$style.account">
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:main>
        <div :class="$style.content">
          <p>游戏账号</p>
          <div>
            <input v-model="form.account" />
          </div>
          <p>游戏密码</p>
          <div>
            <input v-model="form.password" />
          </div>
          <section :class="$style.tips">
            <p>
              <input
                type="checkbox"
                v-model="form.sync"
              />将该账号绑定到平台上，后续可获得丰富奖励；
            </p>
            <p>获得的代金券，将自动发放至该账号</p>
          </section>
          <p @click="handleConcat">联系客服</p>
        </div>
      </template>
      <template v-slot:btn>
        <img :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_quxiao.png`" @click="closeDialog" />
        <img
          :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_queren.png`"
          @click="confirmBindAccount(2)"
        />
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="dialogType === 'gameAccountTips'" :class="$style['game-account']">
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:main>
        <div :class="$style.content">
          <p>您当前的游戏账号</p>
          <p>{{ forumAccount }}</p>
          <p>您是否需要使用该游戏账号参与抢券活动</p>
          <p>获得的代金券，将直接发放到该账号下</p>
        </div>
      </template>
      <template v-slot:btn>
        <img
          :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_huanbang.png`"
          @click="changeBindAccount"
        />
        <img
          :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_queren.png`"
          @click="confirmBindAccount(1)"
        />
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="dialogType === 'firstTask'" :class="$style['first-task']">
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:main>
        <div :class="$style.content">
          <p>在游戏中，当天进行任意一笔充值，即可完成任务</p>
        </div>
      </template>
      <template v-slot:btn>
        <img :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_queren.png`" @click="closeDialog" />
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="dialogType === 'pickSuccess'" :class="$style['pick-success']">
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:main>
        <div :class="$style.content">
          <p>
            礼包码：<span>{{ giftCode }}</span>
          </p>
          <button id="copyBtn"></button>
          <p>礼包有时间限制，请尽快在游戏中兑换</p>
        </div>
      </template>
      <template v-slot:btn>
        <img :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_queren.png`" @click="closeDialog" />
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="dialogType === 'pickGift'" :class="$style['pick-gift']" :isSwiper="true">
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:pickGift>
        <div :class="$style.content">
          <div v-if="!isBindAccount" :class="$style['no-bind']">
            <p>您还未绑定游戏账号</p>
            <p @click="handleBindAccount">点击此处绑定</p>
          </div>
          <div v-if="isBindAccount && ownerGameList.length" :class="$style['has-game-list']">
            <p>您的游戏</p>
            <div :class="$style['game-list']">
              <div v-for="item of ownerGameList" :key="item.id" :class="$style.item">
                <div :class="$style['game-info']">
                  <p>{{ item.name }}</p>
                  <p v-if="item.can_get">游戏礼包</p>
                  <p v-else>礼包码：{{ item.code }}</p>
                </div>
                <button
                  v-if="item.can_get"
                  :class="$style['pick-btn']"
                  @click="handlePickGift(item)"
                ></button>
                <button
                  v-else
                  class="copyCode"
                  :class="$style['copy-btn']"
                  :data-clipboard-text="item.code"
                ></button>
              </div>
            </div>
          </div>
          <div v-if="isBindAccount && !ownerGameList.length" :class="$style['no-game-list']">
            <p>您激活的游戏未参与本次活动，</p>
            <p>进入下方推荐的游戏，激活后即</p>
            <p>可<span>领取礼包！</span></p>
          </div>
          <div v-if="gameRecommendList.length" :class="$style['game-recommend']">
            <p>游戏推荐</p>
            <swiper :class="$style['game-recommend-list']" :options="swiperOptionsHor">
              <swiper-slide
                v-for="item in gameRecommendList"
                :key="item.id"
                :class="$style['list-item']"
              >
                <template>
                  <img :src="item.background" />
                  <div :class="$style['down-load']">
                    <p>{{ item.name }}</p>
                    <button class="swiper-btn" @click="handleDown(item.url)"></button>
                  </div>
                </template>
              </swiper-slide>
              <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper
      v-if="dialogType === 'actOver'"
      :class="$style['act-over']"
      :isShowCloseBtn="false"
    >
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:main>
        <div :class="$style.content">
          <p>本次活动已结束！</p>
        </div>
      </template>
      <template v-slot:btn>
        <img :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_queren.png`" @click="linkTo" />
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="dialogType === 'actNotStart'" :class="$style['act-over']">
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:main>
        <div :class="$style.content">
          <p>当前活动未开始，请于4月25日来参加哦！</p>
        </div>
      </template>
      <template v-slot:btn>
        <img :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_queren.png`" @click="closeDialog" />
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="dialogType === 'advanceNotice'" :class="$style['act-over']">
      <template v-slot:title>
        <div :class="$style.banner"></div>
      </template>
      <template v-slot:main>
        <div :class="$style.content">
          <p>
            {{
              !isLastDay
                ? `今日代金券已抢完，下一场活动明日${isThirdDay ? 18 : 9}：30开始哦！`
                : '本时段奖品已抢完，活动已结束！更多精彩请持续关注公众号。'
            }}
          </p>
        </div>
      </template>
      <template v-slot:btn>
        <img :src="`${$cdnUrl}/seckill/dialog/popup/tankuang_queren.png`" @click="closeDialog" />
      </template>
    </DialogWrapper>
  </div>
</template>

<script>
import DialogWrapper from './DialogWrapper';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Toast } from 'vant';
import Clipboard from "clipboard";
import { seckillBindAccount, seckillPickGift, forumBindAccount } from '@/api/activity.js';
import { mapState, mapMutations, mapActions } from 'vuex';
import 'swiper/css/swiper.css'
let vm = ''
export default {
  components: {
    DialogWrapper,
    Swiper,
    SwiperSlide
  },
  props: {
    dialogType: {
      type: String,
      default: ''
    },
    ownerGameList: {
      type: Array,
      default: () => []
    },
    gameRecommendList: {
      type: Array,
      default: () => []
    },
    isBindAccount: {
      type: Boolean,
      default: false
    },
    isLastDay: {
      type: Boolean,
      default: false
    },
    isThirdDay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      giftCode: '', // 领取成功弹窗中的礼包码
      form: {
        account: undefined,
        password: undefined,
        sync: undefined
      },
    };
  },
  computed: {
    ...mapState('activity', {
      forumAccount: state => state.forumAccount
    }),
    // 活动id
    activityId() {
      return Number(this.$route.query.activity_id)
    },
    // 推荐游戏banner
    swiperOptionsHor() {
      return {
        autoplay: true,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 3,
        preventClicks: false,
        pagination: {
          el: '.swiper-pagination',
          bulletActiveClass: 'seckill-bullet-active',
        },
        on: {
          click(e) {
            let realIndex = this.realIndex
            vm.handleLink(vm.gameRecommendList[realIndex])
          }
        }
      }
    },
  },
  watch: {
    dialogType(newValue) {
      if (newValue === 'showBindAccount') {
        this.form = {}
      }
    }
  },
  created() {
    vm = this
  },
  mounted() {
    this.copyInit()
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
    }),
    ...mapActions('activity', {
      getForumBindAccount: 'getForumBindAccount',
    }),
    copyInit() {
      // 礼包领取成功弹窗中点击复制
      this.copy = new Clipboard("#copyBtn", {
        text: () => {
          return this.giftCode
        }
      });
      this.copy.on("success", e => {
        this.$toast.success("复制成功");
      });
      // 领取游戏礼包弹窗中的点击复制
      this.copyOne = new Clipboard(".copyCode")
      this.copyOne.on("success", e => {
        this.$toast.success("复制成功");
      });
    },
    async handlePickGift(item) {
      this.CHANGE_SHOW_LOADING(true)
      const r = await seckillPickGift({
        lucky_draw_id: this.activityId,
        id: item.id
      })
      this.giftCode = r.data.code
      setTimeout(() => {
        this.CHANGE_SHOW_LOADING(false)
        this.$bus.$emit('openSeckillDialog', 'pickSuccess')
      }, 500);
    },
    handleLink(item) {
      this.CHANGE_SHOW_LOADING(true)
      setTimeout(() => {
        this.CHANGE_SHOW_LOADING(false)
        window.open(item.url, "_self");
      }, 500);
    },
    // 回到首页
    linkTo() {
      this.$router.push({ name: "gameCircleCenter.home" });
    },
    closeDialog() {
      this.$bus.$emit('closeSeckillDialog')
    },
    // 换绑账号
    changeBindAccount() {
      this.$bus.$emit('openSeckillDialog', 'showBindAccount')
    },
    // 确认绑定账号
    async confirmBindAccount(type) {
      let r = {}
      if (type == 1) {
        try {
          r = await seckillBindAccount({
            bind_type: 1
          })
        } catch (error) {
          Toast.fail(error.message)
          return
        }
      } else {
        if (!this.form.account) {
          Toast("请输入游戏账号")
          return
        }
        if (!this.form.password) {
          Toast("请输入游戏密码")
          return
        }
        this.form = Object.assign(this.form, {
          sync: this.form.sync ? 1 : undefined
        })
        try {
          r = await seckillBindAccount({
            bind_type: 2,
            ...this.form
          })
        } catch (error) {
          Toast.fail(error.message)
          return
        }
      }
      Toast.success("绑定成功")
      this.$emit('getSeckillUserInfo')
      this.closeDialog()
    },
    // 点击绑定账号
    handleBindAccount() {
      this.CHANGE_SHOW_LOADING(true)
      this.getForumBindAccount().then(() => {
        this.CHANGE_SHOW_LOADING(false)
        if (!this.isBindAccount && this.forumAccount) {
          // 当平台已绑定，活动未绑定的时候弹出首次绑定弹窗
          this.$bus.$emit('openSeckillDialog', 'gameAccountTips')
        } else {
          this.$bus.$emit('openSeckillDialog', 'showBindAccount')
        }
      })
    },
    // 点击联系客服
    handleConcat() {
      this.$emit('handleConcat')
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable';
@import '~@/styles/mixins.scss';
.account,
.game-account,
.first-task,
.pick-success,
.pick-gift,
.act-over {
  .banner {
    width: 100%;
    height: 39px;
    background-size: 95% auto;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.account {
  .banner {
    background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_biaoti2.png');
  }
  .content {
    position: relative;
    > p {
      font-size: 16px;
      font-weight: 400;
      color: #ede4be;
      line-height: 15px;
    }
    > div {
      width: 243px;
      height: 38px;
      margin-top: 7px;
      background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_shufukuang.png');
      background-size: 100% auto;
      border: 0px solid #b7a169;
      opacity: 0.8;
      > input {
        @include clearBtnDefaultStyle;
        width: 100%;
        height: 100%;
        padding: 11px;
        font-size: 19px;
        font-weight: 400;
        color: #f6da4d;
        line-height: 15px;
      }
    }
    > p:nth-child(3) {
      margin-top: 12.5px;
    }
    .tips {
      margin-top: 9px;
      font-size: 10px;
      font-weight: 400;
      color: #a9a07a;
      line-height: 15px;
      letter-spacing: 1px;
      > p {
        display: inline-block;
      }
      > p:last-child {
        color: #ff6839;
      }
      > p:first-child {
        display: flex;
        align-items: center;
        > input {
          width: 12px;
          height: 12px;
          margin-right: 2px;
        }
      }
    }
    > p:last-child {
      position: absolute;
      right: 0px;
      font-size: 10px;
      font-weight: 400;
      color: #0fdb13;
      line-height: 15px;
    }
  }
}
.game-account {
  .banner {
    background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_biaoti1.png');
  }
  .content {
    text-align: center;
    letter-spacing: 1px;
    > p:first-child {
      margin-top: 30px;
      font-size: 16px;
      font-weight: 400;
      color: #ede4be;
      line-height: 15px;
    }
    > p:nth-child(2) {
      margin-top: 15.3px;
      font-size: 16px;
      font-weight: bold;
      color: #ffdb4c;
      line-height: 15px;
    }
    > p:nth-child(3) {
      margin-top: 62px;
      font-size: 11px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ede4be;
      line-height: 15px;
    }
    > p:last-child {
      font-size: 11px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff6839;
      line-height: 17px;
    }
  }
}
.first-task {
  .banner {
    background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_biaoti3.png');
  }
  .content {
    margin-top: 50px;
    font-size: 15px;
    font-weight: 400;
    color: #ede4be;
    line-height: 24px;
    text-align: center;
  }
}
.pick-success {
  .banner {
    background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_biaoti5.png');
  }
  .content {
    text-align: center;
    > p:first-child {
      margin-top: 15px;
      font-size: 15px;
      font-weight: bold;
      color: #ede4be;
      line-height: 24px;
      > span {
        font-size: 14px;
        font-weight: bold;
        color: #ffdb4c;
        line-height: 9px;
      }
    }
    > button {
      @include clearBtnDefaultStyle;
      width: 78px;
      height: 27px;
      margin-top: 23.3px;
      background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_dianjifuzhi.png');
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
    > p:last-child {
      margin-top: 48.3px;
      font-size: 10px;
      font-weight: 400;
      color: #a9a07a;
      line-height: 15px;
    }
  }
}
.pick-gift {
  .banner {
    background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_biaoti4.png');
  }
  .content {
    height: 305px;
    .no-bind {
      width: 100%;
      height: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p:first-child {
        font-size: 15px;
        font-weight: bold;
        color: #ede4be;
      }
      p:last-child {
        margin-top: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #ecda45;
        text-decoration: underline;
      }
    }
    .has-game-list {
      width: 100%;
      height: 160px;
      > p:first-child {
        font-size: 15px;
        font-weight: bold;
        color: #ede4be;
        letter-spacing: 1px;
        margin-bottom: 5px;
      }
      .game-list {
        width: 100%;
        height: 160px;
        overflow-y: auto;
        .item {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 100%;
          height: 58px;
          padding: 0 10px;
          margin-top: 4px;
          background: #3e2725;
          border-radius: 4px;
          .game-info {
            position: relative;
            width: 75%;
            > p:first-child {
              font-size: 14px;
              font-weight: 400;
              color: #ecda45;
              line-height: 9px;
              letter-spacing: 1px;
            }
            > p:last-child {
              margin-top: 11px;
              font-size: 13px;
              font-weight: 400;
              color: #e3da8f;
              line-height: 9px;
            }
          }
          .pick-btn,
          .copy-btn {
            @include clearBtnDefaultStyle;
            width: 78px;
            height: 27px;
            margin-left: 5px;
          }
          .pick-btn {
            background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_dianjilingqu.png');
          }
          .copy-btn {
            background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_dianjifuzhi.png');
          }
        }
      }
      .game-list::-webkit-scrollbar {
        width: 3px !important;
      }
      .game-list::-webkit-scrollbar-thumb {
        background: #a08c7b;
        border-radius: 1px;
      }
    }
    .no-game-list {
      width: 100%;
      height: 160px;
      padding-top: 50px;
      text-align: center;
      > p {
        font-size: 15px;
        font-weight: 400;
        color: #ede4be;
        line-height: 24px;
        > span {
          color: #ffbb03;
        }
      }
    }
    .game-recommend {
      position: relative;
      width: 100%;
      margin-top: 25px;
      > p:first-child {
        font-size: 15px;
        font-weight: bold;
        color: #ede4be;
        letter-spacing: 1px;
        margin-bottom: 5px;
      }
      .game-recommend-list {
        .list-item {
          position: relative;
          > img {
            width: 100%;
            height: 100px;
          }
          .down-load {
            position: absolute;
            display: flex;
            align-items: center;
            bottom: 0px;
            width: 100%;
            height: 30px;
            background: rgba(49, 18, 18, 0.7);
            > p {
              flex: auto;
              margin-left: 13px;
              font-size: 13px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ead66a;
              line-height: 9px;
            }
            > button {
              @include clearBtnDefaultStyle;
              position: relative;
              z-index: 10;
              width: 66px;
              height: 18px;
              margin-right: 9px;
              background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_xiazaiyouxi.png');
            }
          }
        }
      }
    }
  }
}
.act-over {
  .banner {
    background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_biaoti1.png');
  }
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    > p {
      font-size: 16px;
      font-weight: 400;
      color: #ede4be;
      line-height: 20px;
      letter-spacing: 1px;
    }
  }
}
</style>
<style>
.seckill-bullet-active {
  background-color: #ffd164;
  opacity: 1;
}
</style>
